
import { Component, OnInit,Input} from '@angular/core';
import { Mode } from 'src/core/utility/enums/enums';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'adahi-message',
    templateUrl: './message.component.html',
   
    
  })
  export class MessageComponent implements  OnInit {
   
    
    @Input() mode: Mode = Mode.Success;
    @Input() showH4: boolean = true;
    @Input() message: string;
    
    enumMode = Mode;
    
    ngOnInit(): void {
    }

    

  }